export type { InstructorsPageProps } from "./InstructorsPage";
export { InstructorsPage } from "./InstructorsPage";
